import esTranslations from '../../resources/translations/es'

export default {
  main: {
    logged: sessionStorage.getItem('logged'),
    sessionData: sessionStorage.getItem('sessionData') ? JSON.parse(sessionStorage.getItem('sessionData')) : null,
    translate: esTranslations
  }
}
